import fetchApi from '@/utils/fetchApi'
import type { DispatchMetadata } from 'shared/src'

interface SendLiveConfigurationParams {
  backendUrl: string
  phoneNumber: string
  jwtToken: string
  payload: DispatchMetadata | null
}

export const useLiveConfigurationApi = () => {
  const assignLivePhoneNumber = async ({
    backendUrl,
    phoneNumber,
    jwtToken,
    payload,
  }: SendLiveConfigurationParams) => {
    try {
      await fetchApi({
        endpoint: `webhook/d50d5454-69e4-4f5a-abb3-3346c04ec495/v1/configurations/${phoneNumber}`,
        method: 'POST',
        jwtToken,
        backendUrl,
        body: payload,
        rawToken: true,
      })
    } catch (err) {
      console.error(`[LiveConfig] Failed to assign phone number:`, err)
      throw err
    }
  }

  return { assignLivePhoneNumber }
}
